<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품 맞춤DB 조회"
      desc="등록한 상품들의 파라미터 현황을 조회할 수 있습니다."></admin-filter>

    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="$router.push('param/create')">등록하기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <!-- 맞춤 DB 타입 -->
      <span slot="param_type" slot-scope="props">{{ convertFormat(props.item.format) }}</span>

      <!-- 선택형 선택지 -->
      <div slot="choice_items" slot-scope="props" v-if="props.item.choice_items.length>0">
        <div v-for="(item,idx) in props.item.choice_items"
             :key="'choice-'+idx">
          <span v-if="idx<3">{{ item.name }}</span>
        </div>
        <div v-if="props.item.choice_items.length>2">...</div>
      </div>

      <!-- 수정/삭제 -->
      <div slot="modify_delete" slot-scope="props">
        <button class="button half" @click.stop.prevent="clickProd(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button is-danger half" @click.stop.prevent="clickProd(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
    <modal name="guideModal" :width="1000" height="auto" :adaptive="true" class="modal-style">
      <div style="height:90vh">
        <notions docType="product"></notions>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../module/common/LpModal.vue'
  import ListMixin from '@/mixins/ListMixin'
  import ParamMixin from "@/mixins/ParamMixin";
  import Notions from "../../module/common/Notions";

  export default {
    name: 'ProductParamList',
    layout:'Main',
    mixins: [
      ListMixin,
      ParamMixin
    ],
    components: {
      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool,
      Notions
    },
    watch: {
      $route(n) {
        //console.log(this.$route.fullPath)
        // this.getData();
      }
    },
    mounted() {
      this.$nextTick(()=>{
        if(this.$route.query.guide) {
          this.$modal.show('guideModal');
        }
      });
    },
    data () {
      return {
        mode:'',
        // searchVal: '',
        nowTime: '',
        nowOpened: '',
        // 상품별 기획전 등록 여부 체크박스 Array (모든 상품)
        modalProd: 0,
      }
    },
    created() {
      this.init();

    },
    methods: {
      init() {
        this.initializing('product_param', 'product/param');
      },
      getDataFromServer() {
        this.getData();
      },
      clickProd(item, kind) {
        if(kind === 'update') {
          this.$router.push(this.getPath('product/param/create?id='+item.id));
        }else if(kind === 'delete') {
          this.modalProd = item.id;
          //this.$refs.deleteModal.open();
          let value = {
            id: item.id,
            url: 'product/param/',
            title: '맞춤 DB를 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  //@import '~assets/css/lp_main'

  .tr-whole-borde th
    padding 12px 6px
    text-align center
  .many-field-tr td
    padding 6px

  .td-btn
    cursor pointer
  .td-btn:hover
    background-color #caf6ec
    font-weight bold
    font-size 1rem
    color $primary

  .prod-list-page-selected
    color #18a4ed
  .prod-list-page-not-selected
    color #666

  .primary
    color $primary

  .prod-tag
    background-color #ebab39
    display inline-block
    padding 4px 10px
    color #fff
    border-radius 3px
    margin 2px

  .prod-search-bgcolor
    background-color #f1f7f8
</style>
